export default __webpack_public_path__ + "static/media/ag-grey.2a6bf156.svg";